// src/helpers/urlProcessingOrder.ts
import ISitemapUrl from '@/interfaces/IUrl';
import UrlTypes from '@/enums/UrlTypes';

/**
 * Defines the execution order for different URL types during processing.
 */
const processingOrder: Record<UrlTypes, number> = {
    [UrlTypes.CATEGORY_HUB]: 0,
    [UrlTypes.CATEGORY]: 1,
    [UrlTypes.UNCLASSIFIED]: 2,
    [UrlTypes.PRODUCT]: 3,
    [UrlTypes.PAGE]: 4,
    [UrlTypes.OTHER]: 5,
    [UrlTypes.CATEGORY_DESCRIPTION]: 6,
    [UrlTypes.PRODUCT_DESCRIPTION]: 7,
    [UrlTypes.PAGE_DESCRIPTION]: 8,
};

/**
 * Orders an array of sitemap URL objects by their processing priority.
 * @param urls - Array of ISitemapUrl objects to order
 * @returns A new array of ISitemapUrl sorted by processing priority
 */
export function orderUrlsByProcessingPriority(urls: ISitemapUrl[]): ISitemapUrl[] {
    return [...urls].sort((a, b) => {
        const aOrder = processingOrder[a.urlType] ?? processingOrder[UrlTypes.UNCLASSIFIED];
        const bOrder = processingOrder[b.urlType] ?? processingOrder[UrlTypes.UNCLASSIFIED];
        return aOrder - bOrder;
    });
}
